import React from 'react';
import Select from '../shared/Select';
import { ACTIVITY_CATEGORIES, ACTIVITY_RANGES } from '../../../models/ActivitiesModel';
import '../Library/Library.css'; // library-count-line

const CATEGORY_OPTIONS = [{ value: 'all', label: 'All categories' }, ...ACTIVITY_CATEGORIES.map((c) => ({ value: c, label: c }))];

/**
 * The log's search, date range and category, one under another, as the
 * prototype stacks them. They stay mounted through no results, so the search
 * keeps its focus and caret; with nothing matching, the line under them
 * carries the way out.
 */
function ActivityFilters({ filters, empty, searchRef, onFilterChange, onClear }) {
  return (
    <>
      <input
        ref={searchRef}
        type="text"
        className="resui-input activities-filter"
        placeholder="Search activity"
        aria-label="Search activity"
        value={filters.search}
        onChange={(e) => onFilterChange('search', e.target.value)}
      />
      <div className="activities-filter">
        <Select
          ariaLabel="Date range"
          value={filters.range}
          options={ACTIVITY_RANGES}
          scale
          className="resui-select-field--block"
          onChange={(v) => onFilterChange('range', v)}
        />
      </div>
      <div className="activities-filter">
        <Select
          ariaLabel="Category"
          value={filters.category}
          options={CATEGORY_OPTIONS}
          scale
          className="resui-select-field--block"
          onChange={(v) => onFilterChange('category', v)}
        />
      </div>

      {empty && (
        <p className="library-count-line activities-none">
          No activity found.{' '}
          <button type="button" className="resui-link" onClick={onClear}>Clear search and filters</button>
        </p>
      )}
    </>
  );
}

export default ActivityFilters;
